import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { CartProvider } from "@/context/CartContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import ShowUp from "@/pages/ShowUp";
import About from "@/pages/About";
import Checkout from "@/pages/Checkout";
import Archive07 from "@/pages/Archive07";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import OrderLookup from "@/pages/OrderLookup";
import DropAdmin from "@/pages/DropAdmin";
import ShopAdmin from "@/pages/ShopAdmin";

const TOAST_OPTIONS = { style: { background: "#111111", color: "#F3EEE3", border: "2px solid #C4281C", borderRadius: "2px" } };

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const NotFound = () => (
  <div className="max-w-2xl mx-auto px-5 pt-28 text-center" data-testid="not-found-page">
    <p className="font-college text-5xl text-navy">WRONG TURN.</p>
    <p className="text-sm text-ink/60 mt-4">This page doesn't exist — but the route home always does.</p>
    <a href="/" className="inline-block mt-8 bg-navy text-paper font-college text-xl px-8 py-3 shadow-print hover:bg-red transition-colors">
      BACK HOME
    </a>
  </div>
);

function Site() {
  const { pathname } = useLocation();
  const bare = pathname === "/archive/07";
  return (
    <CartProvider>
      <ScrollToTop />
      {!bare && <Header />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop/:slug" element={<ProductDetail />} />
          <Route path="/show-up" element={<ShowUp />} />
          <Route path="/about" element={<About />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/archive/07" element={<Archive07 />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/order-lookup" element={<OrderLookup />} />
          <Route path="/drop-admin" element={<DropAdmin />} />
          <Route path="/shop-admin" element={<ShopAdmin />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      {!bare && <Footer />}
      <CartDrawer />
      <Toaster position="top-center" toastOptions={TOAST_OPTIONS} />
    </CartProvider>
  );
}

function App() {
  return (
    <div className="App min-h-screen relative">
      <div
        aria-hidden
        data-testid="site-watermark"
        className="fixed inset-0 z-0 pointer-events-none flex items-center justify-center overflow-hidden"
      >
        <span className="font-college text-[42vw] leading-none text-navy/[0.12] blur-[6px] whitespace-nowrap select-none">
          RUNRS
        </span>
      </div>
      <div className="relative z-10 min-h-screen flex flex-col">
        <BrowserRouter>
          <Site />
        </BrowserRouter>
      </div>
    </div>
  );
}

export default App;
